document.addEventListener('DOMContentLoaded', () => {
  const galleryElement = document.querySelector('.product__media-list');
  if (!galleryElement) return;

  let viewer;

  function initViewer() {
    // Destroy existing instance (important for variant changes / editor rerenders)
    if (viewer) viewer.destroy();

    viewer = new Viewer(galleryElement, {
      // Use Dawn's HD link if present, otherwise use current loaded image
      url(image) {
        const link = image.closest('.product__modal-opener');
        return link ? link.href : (image.currentSrc || image.src);
      },

      // Ensure we only include relevant images
      filter(image) {
        return !!image.closest('.product__media-item, .product__modal-opener');
      },

      // UI
      button: true,
      navbar: true,
      title: true,
      toolbar: {
        zoomIn: 1,
        zoomOut: 1,
        oneToOne: 1,
        reset: 1,
        prev: 1,
        next: 1,
        rotateLeft: 0,
        rotateRight: 0,
        flipHorizontal: 0
      },

      // Interaction
      backdrop: 'rgba(0, 0, 0, 0.9)',
      className: 'custom-viewer-theme'
    });

    // Disable Dawn default "open modal" click
    galleryElement.querySelectorAll('.product__modal-opener').forEach(opener => {
      opener.addEventListener('click', (e) => e.preventDefault());
    });
  }

  initViewer();

  // Re-init when Dawn swaps media list on variant change
  const obs = new MutationObserver(() => {
    clearTimeout(window.__sleepcityViewerReinit);
    window.__sleepcityViewerReinit = setTimeout(initViewer, 60);
  });

  obs.observe(galleryElement, { childList: true, subtree: true });
});
